import buildService from 'common/utils/build-service'
import { DELETE, GET, PATCH, POST } from 'common/requests'

interface EmotionWordsUrlParams {
  onlyMoodMeter?: boolean
  onlyCharter?: boolean
}

interface EmotionWordIdParams {
  id: string
}

export default buildService<EmotionWordsUrlParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'EMOTION_WORDS',
  isArray: true,
  http: {
    createApiUrlSuffix: (urlParams) => {
      if (urlParams.onlyMoodMeter) {
        return '/emotion_words?order=name.asc&mood_meter=eq.true'
      }
      if (urlParams.onlyCharter) {
        return '/emotion_words?order=name.asc&charter=eq.true'
      }
      return `/emotion_words?order=name.asc`
    },
  },
})

export const postEmotionWordService = buildService<
  Record<string, never>,
  unknown,
  unknown,
  unknown
>({
  type: POST,
  constantsPrefix: 'EMOTION_WORD',
  http: {
    createApiUrlSuffix: () => {
      return `/emotion_words`
    },
  },
})

export const deleteEmotionWordService = buildService<
  EmotionWordIdParams,
  unknown,
  unknown,
  unknown
>({
  type: DELETE,
  constantsPrefix: 'EMOTION_WORD',
  http: {
    createApiUrlSuffix: ({ id }) => {
      return `/emotion_words?id=eq.${id}`
    },
  },
})

export const patchEmotionWordService = buildService<EmotionWordIdParams, unknown, unknown, unknown>(
  {
    type: PATCH,
    constantsPrefix: 'EMOTION_WORD',
    http: {
      createApiUrlSuffix: ({ id }) => `/emotion_words?id=eq.${id}`,
    },
  },
)
